/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetGcpIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetGcpIamCredentialRequest = {
  /**
   * The ID of the credential to get.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetGcpIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  GetGcpIamCredentialSecurity$Outbound,
  GetGcpIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getGcpIamCredentialSecurityToJSON(
  getGcpIamCredentialSecurity: GetGcpIamCredentialSecurity,
): string {
  return JSON.stringify(
    GetGcpIamCredentialSecurity$outboundSchema.parse(
      getGcpIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type GetGcpIamCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetGcpIamCredentialRequest$outboundSchema: z.ZodMiniType<
  GetGcpIamCredentialRequest$Outbound,
  GetGcpIamCredentialRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getGcpIamCredentialRequestToJSON(
  getGcpIamCredentialRequest: GetGcpIamCredentialRequest,
): string {
  return JSON.stringify(
    GetGcpIamCredentialRequest$outboundSchema.parse(getGcpIamCredentialRequest),
  );
}
